export default __webpack_public_path__ + "static/media/course9.688bb9a0.png";